import React from 'react';
import styles from './MyAccount.module.css';
import { useUserProfile } from '../../hooks/useUserProfile';
import { User, Mail, Phone, Calendar, Globe, UserCheck } from 'lucide-react';

const UserData = () => {
  const { userData, isLoading, error } = useUserProfile();

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Helper function to capitalize first letter
  const capitalizeFirst = (str) => {
    if (!str) return 'N/A';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  if (isLoading) {
    return (
      <div className={styles.userInfo}>
        <div className={styles.loadingContainer}>
          <div className={styles.loadingSpinner}></div>
          <p>Loading your profile...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.userInfo}>
        <div className={styles.errorContainer}>
          <div className={styles.errorIcon}>⚠️</div>
          <p>Failed to load user data. Please try again later.</p>
        </div>
      </div>
    );
  }

  const user = userData?.user;

  return (
    <div className={styles.userInfo}>
      <div className={styles.profileHeader}>
        <div className={styles.avatarSection}>
          <div className={styles.avatar}>
            <User size={40} />
          </div>
          <div className={styles.userStatus}>
            <span className={styles.statusBadge}>
              <UserCheck size={16} />
              {capitalizeFirst(user?.role || 'User')}
            </span>
          </div>
        </div>
      </div>

      <div className={styles.infoGrid}>
        <div className={styles.infoCard}>
          <div className={styles.infoIcon}>
            <User size={20} />
          </div>
          <div className={styles.infoContent}>
            <label>Full Name</label>
            <p>{user?.name || 'N/A'}</p>
          </div>
        </div>

        <div className={styles.infoCard}>
          <div className={styles.infoIcon}>
            <Mail size={20} />
          </div>
          <div className={styles.infoContent}>
            <label>Email Address</label>
            <p>{user?.email || 'N/A'}</p>
          </div>
        </div>

        <div className={styles.infoCard}>
          <div className={styles.infoIcon}>
            <Phone size={20} />
          </div>
          <div className={styles.infoContent}>
            <label>Phone Number</label>
            <p>{user?.phone || 'N/A'}</p>
          </div>
        </div>

        <div className={styles.infoCard}>
          <div className={styles.infoIcon}>
            <User size={20} />
          </div>
          <div className={styles.infoContent}>
            <label>Gender</label>
            <p>{capitalizeFirst(user?.gender) || 'N/A'}</p>
          </div>
        </div>

        <div className={styles.infoCard}>
          <div className={styles.infoIcon}>
            <Calendar size={20} />
          </div>
          <div className={styles.infoContent}>
            <label>Date of Birth</label>
            <p>{formatDate(user?.dob) || 'N/A'}</p>
          </div>
        </div>

        <div className={styles.infoCard}>
          <div className={styles.infoIcon}>
            <Globe size={20} />
          </div>
          <div className={styles.infoContent}>
            <label>Preferred Language</label>
            <p>{capitalizeFirst(user?.language) || 'N/A'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserData;